<template>
    <sys-register-base 
        :loading="loading" 
        @onSave="save" 
        :model.sync="model" 
        :title="title" 
        :icon="icon"
        v-bind:show.sync="dialog"
        maxWidth="50%"
    >
        <template v-slot:tools>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-menu
                        v-model="viewMenu"
                        offset-x
                        offset-y
                        bottom
                        :close-on-content-click="false"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <template v-slot:activator="{ on: onMenu, attrs: attrsMenu }">
                            <v-btn
                                fab
                                color="primary"
                                x-small
                                v-bind="attrsMenu"
                                v-on="{ ...on, ...onMenu }"
                            >
                                <v-icon small>mdi-tag-plus-outline</v-icon>
                            </v-btn>
                        </template>
                        <v-list dense class="py-0">
                            <v-subheader class="caption font-weight-bold">Conteúdo do termo</v-subheader>
                            <emc-util-scroll maxHeight="200px">
                                <v-list-item
                                    v-for="(tag, i) in tags"
                                    :key="'content-' + i"
                                    link
                                    @click="setField(tag)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title class="text-body-2">{{ tag.tag }}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </emc-util-scroll>
                            <v-divider v-if="model && model.send_email" />
                            <v-subheader v-if="model && model.send_email" class="caption font-weight-bold">Corpo do e-mail</v-subheader>
                            <template v-if="model && model.send_email">
                                <v-list-item
                                    v-for="(tag, i) in emailTags"
                                    :key="'email-' + i"
                                    link
                                    @click="setEmailField(tag)"
                                >
                                    <v-list-item-content>
                                        <v-list-item-title class="text-body-2">{{ tag.tag }}</v-list-item-title>
                                        <v-list-item-subtitle class="caption">{{ tag.description }}</v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </template>
                        </v-list>
                    </v-menu>
                </template>
                <span>Inserir tag — Ctrl+Shift+T</span>
            </v-tooltip>
        </template>
    
        <template v-slot:form>
            <v-container>
                    <v-row>
                        <v-col cols="12" sm="8">
                            <v-text-field autofocus :error="!!errors.name" :error-messages="errors.name" v-model="model.name" label="Nome*"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-text-field code :error-messages="errors.code" v-model="model.code" label="Código"/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <v-textarea
                                :error="!!errors.description" 
                                :error-messages="errors.description" 
                                v-model="model.description" 
                                label="Descrição*"
                                :counter="255"
                                rows="2"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                                outlined
                            />
                        </v-col>
                    </v-row>
                    <!-- RN01: Múltiplas Opções de Resposta -->
                    <v-row>
                        <v-col cols="12">
                            <v-divider class="my-3"></v-divider>
                            <v-card flat class="grey lighten-5 pa-3 rounded">
                                <div class="d-flex align-center justify-space-between mb-3">
                                    <div>
                                        <span class="subtitle-1 font-weight-medium">
                                            <v-icon color="primary" class="mr-2">mdi-format-list-checks</v-icon>
                                            Opções de Resposta
                                        </span>
                                        <div class="caption grey--text mt-1">
                                            Defina as opções que o usuário poderá escolher ao responder este termo
                                        </div>
                                    </div>
                                    <v-btn 
                                        small 
                                        color="primary"
                                        @click="addTermOption"
                                        class="ml-2"
                                    >
                                        <v-icon small left>mdi-plus</v-icon>
                                        Nova Opção
                                    </v-btn>
                                </div>

                                <!-- Lista de Opções -->
                                <div v-for="(option, index) in model.term_options" :key="index" class="mb-2">
                                    <v-card outlined class="pa-3" :class="{ 'border-success': option.is_valid_acceptance }">
                                        <v-row no-gutters align="center">
                                            <!-- Número da opção -->
                                            <v-col cols="auto" class="mr-3">
                                                <v-avatar 
                                                    size="28" 
                                                    :color="option.is_valid_acceptance ? 'success' : 'grey lighten-1'"
                                                    class="white--text caption font-weight-bold"
                                                >
                                                    {{ index + 1 }}
                                                </v-avatar>
                                            </v-col>
                                            
                                            <!-- Campo de texto do rótulo -->
                                            <v-col cols="12" sm="5" class="pr-2">
                                                <v-text-field
                                                    v-model="option.label"
                                                    label="Texto da opção"
                                                    placeholder="Ex: Li e concordo com os termos"
                                                    persistent-placeholder
                                                    dense
                                                    outlined
                                                    hide-details="auto"
                                                    :rules="[v => !!v || 'Obrigatório']"
                                                    :error="!!(errors['term_options.' + index + '.label'])"
                                                    :error-messages="errors['term_options.' + index + '.label']"
                                                />
                                            </v-col>
                                            
                                            <!-- Configurações da opção -->
                                            <v-col cols="12" sm class="d-flex align-center flex-wrap">
                                                <!-- Aceite válido -->
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            :color="option.is_valid_acceptance ? 'success' : 'grey lighten-3'"
                                                            :text-color="option.is_valid_acceptance ? 'white' : 'grey darken-1'"
                                                            small
                                                            class="mr-2 mb-1"
                                                            @click="option.is_valid_acceptance = !option.is_valid_acceptance"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon x-small left>{{ option.is_valid_acceptance ? 'mdi-check-circle' : 'mdi-check-circle-outline' }}</v-icon>
                                                            Aceite
                                                        </v-chip>
                                                    </template>
                                                    <span>
                                                        <strong>Aceite Válido:</strong> Quando ativado, esta opção representa<br>
                                                        a concordância do usuário (status "Assinado")
                                                    </span>
                                                </v-tooltip>

                                                <!-- Exigir justificativa -->
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-chip
                                                            :color="option.require_justification ? 'warning' : 'grey lighten-3'"
                                                            :text-color="option.require_justification ? 'white' : 'grey darken-1'"
                                                            small
                                                            class="mr-2 mb-1"
                                                            @click="option.require_justification = !option.require_justification"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon x-small left>{{ option.require_justification ? 'mdi-text-box-check' : 'mdi-text-box-outline' }}</v-icon>
                                                            Justificativa
                                                        </v-chip>
                                                    </template>
                                                    <span>
                                                        <strong>Exigir Justificativa:</strong> Quando ativado, o usuário<br>
                                                        deverá informar o motivo ao selecionar esta opção
                                                    </span>
                                                </v-tooltip>
                                            </v-col>
                                            
                                            <!-- Botão remover -->
                                            <v-col cols="auto">
                                                <v-tooltip bottom>
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-btn
                                                            icon
                                                            small
                                                            :disabled="model.term_options.length <= 1"
                                                            @click="removeTermOption(index)"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                        >
                                                            <v-icon small :color="model.term_options.length <= 1 ? 'grey lighten-1' : 'error'">mdi-delete-outline</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Remover esta opção</span>
                                                </v-tooltip>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </div>

                                <!-- Alerta se não houver opção com aceite válido -->
                                <v-alert 
                                    v-if="model.term_options && model.term_options.length > 0 && !hasValidAcceptanceOption"
                                    type="info" 
                                    dense 
                                    text
                                    class="ma-0 mt-2"
                                >
                                    <v-icon small left color="info">mdi-information</v-icon>
                                    <strong>Dica:</strong> Marque pelo menos uma opção como "Aceite" para identificar qual resposta representa concordância.
                                </v-alert>

                                <!-- Legenda -->
                                <div class="mt-3 d-flex align-center flex-wrap">
                                    <span class="caption grey--text mr-3">Legenda:</span>
                                    <v-chip x-small color="success" text-color="white" class="mr-2">
                                        <v-icon x-small left>mdi-check-circle</v-icon>
                                        Aceite
                                    </v-chip>
                                    <span class="caption grey--text text--darken-1 mr-3">= Representa concordância</span>
                                    <v-chip x-small color="warning" text-color="white" class="mr-2">
                                        <v-icon x-small left>mdi-text-box-check</v-icon>
                                        Justificativa
                                    </v-chip>
                                    <span class="caption grey--text text--darken-1">= Exige motivo/explicação</span>
                                </div>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="12">
                            <span>Conteúdo*</span>
                                
                                <vue-editor 
                                    v-model="model.content"
                                    @selection-change="range = $event"
                                    ref="editor"
                                    :error="!!errors.content" 
                                    :error-messages="errors.content" 
                                    :editorToolbar="customToolbar" 
                                />
                            
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" sm="4">
                            <s-switch inset text-helper="Obrigatório concordar para avançar no cadastro" v-model="model.is_required" label="Obrigatório"/>
                        </v-col>
                        <v-col cols="12" sm="4" v-if="model.is_required">
                            <s-switch inset text-helper="Bloqueia o acesso a Página do Professor até a assinatura" v-model="model.block_point" label="Bloquear acesso a Página do Professor"/>
                        </v-col>
                        <!-- <v-col cols="12" sm="4">
                            <s-switch inset text-helper="Exibir concordância com o termo no Extrato do Professor" v-model="model.include_extract" label="Incluir Extrato"/>
                        </v-col> -->
                        <v-col cols="12" sm="4">
                            <s-switch inset text-helper="Enviar e-mail para o usuário com cópia do termo" v-model="model.send_email" label="Enviar E-mail"/>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <s-switch inset text-helper="Salvar cópia do termo em PDF no Servidor" v-model="model.save_pdf" label="Salvar PDF"/>
                        </v-col>
                    </v-row>

                    <!-- Provider de Assinatura Digital -->
                    <v-row v-if="model.save_pdf">
                        <v-col cols="12" sm="6">
                            <v-select
                                v-model="model.signature_provider"
                                :items="signatureProviderItems"
                                item-text="text"
                                item-value="value"
                                label="Provedor de Assinatura Digital"
                                hint="Assinatura Digital para assinatura qualificada; Interna apenas aceita no sistema"
                                persistent-hint
                                outlined
                                dense
                                clearable
                            />
                        </v-col>
                    </v-row>

                    <!-- Configuração de Comunicação - RN01 -->
                    <v-row v-if="model.send_email">
                        <v-col cols="12">
                            <v-divider class="my-2"></v-divider>
                            <span class="subtitle-2 grey--text text--darken-1">
                                <v-icon small class="mr-1">mdi-email-edit-outline</v-icon>
                                Configuração do E-mail de Comunicação
                            </span>
                        </v-col>
                    </v-row>
                    <v-row v-if="model.send_email">
                        <v-col cols="12">
                            <v-text-field
                                v-model="model.email_subject"
                                label="Assunto do E-mail"
                                :error="!!errors.email_subject"
                                :error-messages="errors.email_subject"
                                placeholder="Ex: Termo de Aceite de Carga Horária"
                                persistent-placeholder
                                hint="Assunto que aparecerá no e-mail enviado ao professor"
                                :counter="255"
                                :rules="[v => (!v || v.length <= 255) || 'Máximo de 255 caracteres atingido']"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-if="model.send_email">
                        <v-col cols="12">
                            <span class="caption grey--text">Corpo do E-mail</span>
                            <vue-editor
                                v-model="model.email_body"
                                ref="emailEditor"
                                :editorToolbar="customToolbar"
                                placeholder="Texto personalizado do e-mail. Tags disponíveis: [[NOME_PROFESSOR]], [[NOME_TERMO]], [[LINK_ASSINATURA]]"
                            />
                            <span class="caption grey--text">
                                Use o botão <v-icon x-small>mdi-tag-plus-outline</v-icon> no cabeçalho ou Ctrl+Shift+T para inserir tags
                            </span>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="4">
                            <v-switch color="purple" inset v-model="model.active" label="Ativo"></v-switch>
                        </v-col>
                    </v-row>
            </v-container>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>

<script>

import { mapActions, mapState } from 'vuex'
export default {
    name: "SysRegisterActivity",
    data: (vm) => ({
        viewMenu: false,
        dialog: false,
        error: false,
        errors: {},
        range: null,
        message: '',
        loading: false,
        tags: [],
        emailTags: [
            { tag: 'NOME_PROFESSOR', description: 'Nome do professor' },
            { tag: 'NOME_TERMO', description: 'Nome do termo' },
            { tag: 'LINK_ASSINATURA', description: 'Link para assinatura' }
        ],
        signatureProviders: {},
        customToolbar: [

                [{ header: [false, 1, 2, 3, 4, 5, 6] }],

                [{ size: ["small", false, "large", "huge"] }],

                ["bold", "italic", "underline"],

                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],

                ["blockquote"],

                [{ list: "ordered" }, { list: "bullet" }],

                [{ indent: "-1" }, { indent: "+1" }],

                [{ color: [] }],

                ["link"],
                
        ]
        
    }),
    created() {
        this.loadTags();
        this.loadSignatureProviders();
        this._tagKeyHandler = (e) => {
            if (e.ctrlKey && e.shiftKey && e.key === 'T') {
                if (this.dialog && this.model) {
                    e.preventDefault();
                    this.viewMenu = true;
                }
            }
        };
    },
    mounted() {
        document.addEventListener('keydown', this._tagKeyHandler);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this._tagKeyHandler);
    },

    computed: {
      ...mapState('auth', ['acesso']),

      signatureProviderItems() {
        const providers = this.signatureProviders;
        return Object.entries(providers).map(([value, text]) => ({ value, text }));
      },
      
      /**
       * Verifica se existe pelo menos uma opção marcada como aceite válido
       * RN02: O administrador deve sinalizar qual opção representa concordância
       */
      hasValidAcceptanceOption() {
          if (!this.model.term_options || this.model.term_options.length === 0) {
              return true; // Não mostrar alerta se não há opções
          }
          return this.model.term_options.some(opt => opt.is_valid_acceptance);
      }
    },

    watch: {
        
        dialog(dialog_new, dialog_old) {
            
            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {
            
            this.dialog = show_new;
            
            if(show_new){
                
                this.error = false;
                this.errors = {};
                this.range = null;

                if(!this.model.id){
                    this.$set(this.model, 'is_required', true);
                    this.$set(this.model, 'send_email', true);
                    this.$set(this.model, 'active', true);
                    this.$set(this.model, 'email_subject', '');
                    this.$set(this.model, 'email_body', '');
                    // RN01: Inicializar com uma opção padrão
                    this.$set(this.model, 'term_options', [
                        { label: '', is_valid_acceptance: true, require_justification: false }
                    ]);
                } else {
                    // Edição: carregar opções da API (term_options ou termOptions - camelCase/snake_case)
                    const optionsFromApi = this.model.term_options || this.model.termOptions;
                    if (optionsFromApi && Array.isArray(optionsFromApi) && optionsFromApi.length > 0) {
                        this.$set(this.model, 'term_options', optionsFromApi.map(opt => ({
                            id: opt.id,
                            label: opt.label || '',
                            code: opt.code,
                            color: opt.color,
                            icon: opt.icon,
                            description: opt.description,
                            is_valid_acceptance: !!opt.is_valid_acceptance,
                            require_justification: !!opt.require_justification,
                            active: opt.active !== false
                        })));
                    } else {
                        this.$set(this.model, 'term_options', []);
                    }
                    // Fallback: se não há opções mas há label legado, criar opção a partir dele
                    if (this.model.term_options.length === 0 && this.model.label) {
                        this.$set(this.model, 'term_options', [
                            { label: this.model.label, is_valid_acceptance: true, require_justification: false }
                        ]);
                    }
                }

            }
        },
        
    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-database-plus"
        },
        title: {
            type: String,
            default: "Cadastro de Termo"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        ...mapActions('term', ['ActionIndexTermTags', 'ActionUpdateTerm', 'ActionCreateTerm', 'ActionGetSignatureProviders']),

        loadTags(){
            
            this.tags = [];
            let payload = {
                column_order: 'tag',
                find_columns: {
                    active: 1,
                }
            }
            
            this.ActionIndexTermTags(payload)
                .then((res) => {
                    this.tags = res.data;
                })
                .catch((error) =>{
                    
                })
                .finally(() => {
                    
                })
        },

        loadSignatureProviders() {
            this.ActionGetSignatureProviders()
                .then((res) => {
                    this.signatureProviders = res.data || res;
                })
                .catch(() => {
                    this.signatureProviders = {};
                });
        },
        
        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            Object.assign(this.model, {institution_id: this.acesso.instituicao.id})

            // Manter label sincronizado com a primeira opção para retrocompatibilidade
            if (this.model.term_options && this.model.term_options.length > 0) {
                const firstValidOption = this.model.term_options.find(opt => opt.is_valid_acceptance) || this.model.term_options[0];
                this.model.label = firstValidOption.label || '';
            }

            if(edit) {
                this.ActionUpdateTerm(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateTerm(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

        setField(tag) {
            const quill = this.$refs.editor?.quill;
            if (!quill) return;

            let range = quill.selection?.savedRange;
            if (!range) {
                const sel = quill.getSelection(true);
                range = sel ? { index: sel.index, length: sel.length } : { index: quill.getLength(), length: 0 };
            }

            const text = ' [[' + tag.tag + ']]';
            quill.insertText(range.index, text);
            this.model.content = quill.root.innerHTML;
            quill.setSelection(range.index + text.length);
            quill.focus();
            this.viewMenu = false;
        },

        setEmailField(tag) {
            const editor = this.$refs.emailEditor;
            if (!editor || !editor.quill) return;

            const range = editor.quill.getSelection(true) || { index: editor.quill.getLength(), length: 0 };
            const text = ' [[' + tag.tag + ']]';
            editor.quill.insertText(range.index, text);
            editor.quill.setSelection(range.index + text.length);
            editor.quill.focus();
            this.viewMenu = false;
        },

        /**
         * Adiciona uma nova opção de resposta
         * RN01: Múltiplas opções de resposta por termo
         */
        addTermOption() {
            if (!this.model.term_options) {
                this.$set(this.model, 'term_options', []);
            }
            const newOption = {
                label: '',
                is_valid_acceptance: false,
                require_justification: false
            };
            // Usar splice para garantir reatividade no Vue 2
            this.model.term_options.splice(this.model.term_options.length, 0, newOption);
        },

        /**
         * Remove uma opção de resposta
         * Deve haver pelo menos uma opção
         */
        removeTermOption(index) {
            if (this.model.term_options.length > 1) {
                this.model.term_options.splice(index, 1);
            }
        }

    }
}
</script>

<style scoped>
.border-success {
    border-color: #4CAF50 !important;
    border-width: 2px !important;
}
</style>